export function SelectMapIcon({
  occupied,
  offline,
  typeId,
  bleTagName,
}: {
  occupied: boolean;
  offline?: boolean;
  typeId?: number;
  bleTagName?: string;
}) {
  if (!typeId) {
    if(occupied) return bleTagName ? "violet_point.png" : "red_point.png";
    return "green_point.png";
  }
  if (offline) {
    switch (typeId) {
      case 1:
        return "gray_point.png";
      case 2:
        return "handicapped_offline.png";
      case 3:
        return "charge_offline.png";
      case 4:
        return "reserved_offline.png";
    }
  }
  if(occupied){
    switch (typeId) {
      case 1:
        return bleTagName ? "violet_point.png" : "red_point.png";
      case 2:
        return bleTagName ? "handicapped_violet.png" : "handicapped_red.png";
      case 3:
        return bleTagName ? "charge_violet.png" : "charge_red.png";
      case 4:
        return bleTagName ? "reserved_violet.png" : "reserved_red.png";
    }
  } else {
    switch (typeId) {
      case 1:
        return "green_point.png";
      case 2:
        return "handicapped_green.png";
      case 3:
        return "charge_green.png";
      case 4:
        return "reserved_green.png";
    }
  }
}
